import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './WhatsIncluded.style';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function WhatsIncluded() {
  const { productConfig } = useProductLandingContext();
  const { whatsIncludedBlock: { title, items = [] } = {} } = productConfig;

  if (items.length === 0) {
    return null;
  }

  return (
    <Stack gap={4}>
      {title && (
        <Heading component="h2" size="xl" wrap="wrap">
          <FormattedMessage id={title} />
        </Heading>
      )}
      <Styled.BenefitList>
        {items?.map((item) => (
          <Styled.BenefitItem key={item.title}>
            <Stack gap={2}>
              {item.icon && (
                <Styled.Icon>
                  <SharedAsset alt="" src={item.icon} width="100%" />
                </Styled.Icon>
              )}
              <Stack gap={1}>
                {item.title && (
                  <Heading size="md">
                    <FormattedMessage id={item.title} />
                  </Heading>
                )}
                {item.description && (
                  <Text color="secondary">
                    <FormattedMessage id={item.description} />
                  </Text>
                )}
              </Stack>
            </Stack>
          </Styled.BenefitItem>
        ))}
      </Styled.BenefitList>
    </Stack>
  );
}

export default WhatsIncluded;
